export const SET_LANGUAGE = Symbol('SET_LANGUAGE');

/**
 * @description
 * Sets the app language
 *
 * @returns {{}}
 */
export function setLanguageAction (countryCode) {

	return {
		type: SET_LANGUAGE,
		countryCode,
	};
}
